var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeleteElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 94.1 77.8",
    style: {
      enableBackground: "new 0 0 94.1 77.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DC2E2E;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.4,53.4c-3.8-5.9-9.3-10.6-15.7-13.5c2.4-2.1,4.4-4.7,5.7-7.7c1.3-2.9,2-6.1,2-9.4c0-6.1-2.4-11.9-6.7-16.2 C48.5,2.4,42.7,0,36.6,0c-6.1,0-11.9,2.4-16.2,6.7c-4.3,4.3-6.7,10.1-6.7,16.2c0,3.2,0.7,6.4,2,9.4c1.3,2.9,3.3,5.6,5.7,7.7 c-6.4,2.9-11.8,7.6-15.7,13.5C2,59.3,0,66.2,0,73.2c0,1.2,0.5,2.4,1.3,3.2c0.9,0.9,2,1.3,3.2,1.3c1.2,0,2.4-0.5,3.2-1.3 c0.9-0.9,1.3-2,1.3-3.2c0-7.3,2.9-14.3,8-19.4c5.2-5.2,12.1-8,19.4-8c7.3,0,14.3,2.9,19.4,8c5.2,5.2,8,12.1,8,19.4 c0,1.2,0.5,2.4,1.3,3.2c0.9,0.9,2,1.3,3.2,1.3s2.4-0.5,3.2-1.3c0.9-0.9,1.3-2,1.3-3.2C73.2,66.2,71.2,59.3,67.4,53.4z M46.3,32.6 c-2.6,2.6-6.1,4-9.7,4c-2.7,0-5.4-0.8-7.6-2.3c-2.3-1.5-4-3.7-5.1-6.2s-1.3-5.3-0.8-7.9c0.5-2.7,1.8-5.1,3.8-7 c1.9-1.9,4.4-3.2,7-3.8c2.7-0.5,5.4-0.3,7.9,0.8c2.5,1,4.7,2.8,6.2,5.1c1.5,2.3,2.3,4.9,2.3,7.6C50.4,26.5,48.9,30,46.3,32.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.7,47.4c-0.9,0-1.7-0.3-2.3-1c-0.6-0.6-1-1.4-1-2.3V22.7h-1.7v-3.3H76v-1.7h9.9v1.7h8.3v3.3h-1.7v21.5 c0,0.9-0.3,1.7-1,2.3c-0.6,0.6-1.4,1-2.3,1H72.7z M76,40.8h3.3V26H76V40.8z M82.6,40.8h3.3V26h-3.3V40.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteElement);
export default __webpack_public_path__ + "static/media/icon_delete_element.8f1e0fdc84901188dc828d375d3c2fad.svg";
export { ForwardRef as ReactComponent };